"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by nina.kirakosyan on 11/18/2020.
 */
var core_1 = require("@angular/core");
var overlay_1 = require("@angular/cdk/overlay");
var portal_1 = require("@angular/cdk/portal");
var sis_ng_tooltip_component_1 = require("./sis-ng-tooltip.component");
var tooltip_configs_model_1 = require("./tooltip-configs.model");
/**
 * Custom sis tooltip-popup directive for displaying texts or dynamic interactive content on hover.
 */
var SisTooltipDirective = /** @class */ (function () {
    function SisTooltipDirective(overlayPositionBuilder, elementRef, overlay) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this.elementRef = elementRef;
        this.overlay = overlay;
        /**
         * The message to be displayed in the tooltip.
         * @type {string}
         */
        this.text = '';
        /**
         * Disables the display of the tooltip.
         * @type {boolean}
         */
        this.disabled = false;
        /**
         * Whether the tooltip works on click vs on hover.
         * @type {boolean}
         */
        this.onClick = false;
        /**
         * Size option for the tooltip
         * @type {SisTooltipSize}
         */
        this.size = 'small';
        this.placement = 'above';
        /**
         * Flag to draw tooltip title.
         * @type {boolean}
         */
        this.showTitle = false;
        /**
         * Flag to show tooltip "don't show again" checkbox.
         * @type {boolean}
         */
        this.showDisableCheckbox = false;
        /**
         * Flag to show button to close tooltip from inside.
         * @type {boolean}
         */
        this.showCloseButton = false;
        /**
         * Emits the change of checkbox value.
         * @type {EventEmitter<boolean>}
         */
        this.onDisableCheck = new core_1.EventEmitter();
        /**
         * Emits when the tooltip disappears.
         * @type {EventEmitter<boolean>}
         */
        this.onTooltipClosed = new core_1.EventEmitter();
        /**
         * Default positioning configs for the tooltip, as initially indicated.
         * May automatically change based on available surrounding space in window.
         * @type {ConnectionPositionPair}
         */
        this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.UP;
        /**
         * Shows whether the tooltip host is being hovered.
         * @type {boolean}
         */
        this.isHostHovered = false;
        /**
         * Shows whether the tooltip component is being hovered.
         * @type {boolean}
         */
        this.isTooltipHovered = false;
        /**
         * Shows whether the tooltip host has been clicked to open tooltip-popup.
         * @type {boolean}
         */
        this.isClicked = false;
    }
    Object.defineProperty(SisTooltipDirective.prototype, "placementType", {
        /**
         * Placement option for the tooltip
         * @type {SisTooltipPlacement}
         */
        set: function (value) {
            this.placement = value;
            this.initTooltipOverlay();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Mouse Enter event for the tooltip host.
     */
    SisTooltipDirective.prototype.onHoverEnter = function () {
        var _this = this;
        if (!this.onClick) {
            this.isHostHovered = true;
            this.tooltipDelay = setTimeout(function () {
                _this.show();
            }, 100);
        }
    };
    /**
     * Mouse Leave event for the tooltip host.
     */
    SisTooltipDirective.prototype.onHoverLeave = function () {
        var _this = this;
        if (!this.onClick) {
            setTimeout(function () {
                _this.isHostHovered = false;
                _this.hide();
            }, 0);
        }
    };
    /**
     * Click-outside event for closing the tooltip.
     */
    SisTooltipDirective.prototype.clickedOutside = function ($event) {
        if (this.onClick) {
            if (this.isClicked && !this.isTooltipHovered) {
                this.isClicked = false;
                this.hide();
            }
        }
    };
    /**
     * Click event for the tooltip host.
     */
    SisTooltipDirective.prototype.onHostClick = function ($event) {
        if (this.onClick) {
            this.onClickToggle();
            $event.stopPropagation();
        }
    };
    SisTooltipDirective.prototype.onClickToggle = function () {
        if (this.onClick) {
            this.isClicked = !this.isClicked;
            if (this.isClicked) {
                this.show();
            }
            else {
                this.hide();
            }
        }
    };
    SisTooltipDirective.prototype.show = function () {
        var _this = this;
        if (!this.disabled && this.overlayRef && !this.overlayRef.hasAttached()) {
            var tooltipPortal = new portal_1.ComponentPortal(sis_ng_tooltip_component_1.SisNgTooltipComponent);
            this.tooltipRef = this.overlayRef.attach(tooltipPortal);
            var tooltip = this.tooltipRef.instance;
            if (this.size == 'x-small' && this.text && this.text.length > 15) {
                this.size = 'small';
            }
            tooltip.id = 'sis-ng-tooltip-component';
            tooltip.text = this.text;
            tooltip.contentTemplate = this.contentTemplate;
            tooltip.disabled = this.disabled;
            tooltip.size = this.size;
            tooltip.placement = this.defaultPosition;
            tooltip.tooltipClass = this.tooltipClass;
            tooltip.title = this.title;
            tooltip.checkboxText = this.checkboxText;
            tooltip.buttonText = this.buttonText;
            tooltip.showTitle = this.showTitle;
            tooltip.showDisableCheckbox = this.showDisableCheckbox;
            tooltip.showCloseButton = this.showCloseButton;
            this.tooltipRef.instance.onHoverChange.subscribe(function (val) {
                if (val) {
                    _this.isTooltipHovered = val;
                    _this.hide();
                }
                else {
                    setTimeout(function () {
                        _this.isTooltipHovered = val;
                        !_this.onClick && _this.hide();
                    }, 0);
                }
            });
            this.tooltipRef.instance.onCheckboxClicked.subscribe(function (val) {
                _this.onDisableCheck.emit(val);
            });
            this.tooltipRef.instance.onCloseAction.subscribe(function (val) {
                _this.isClicked = false;
                _this.isHostHovered = false;
                _this.isTooltipHovered = false;
                _this.hide();
            });
        }
    };
    /**
     * Detaches the tooltip component when neither host nor tooltip are being hovered or the tooltip popup has been closed.
     */
    SisTooltipDirective.prototype.hide = function () {
        clearTimeout(this.tooltipDelay);
        if (!(this.isHostHovered || this.isTooltipHovered || this.isClicked) && this.overlayRef.hasAttached()) {
            this.overlayRef.detach();
            this.onTooltipClosed.emit(true);
        }
    };
    SisTooltipDirective.prototype.ngOnInit = function () {
        this.initTooltipOverlay();
    };
    /**
     * Initializes position strategy and creates the overlay with corresponding configs.
     */
    SisTooltipDirective.prototype.initTooltipOverlay = function () {
        var _this = this;
        var positions = this.getPositions();
        var positionStrategy = this.overlayPositionBuilder
            .connectedTo(this.elementRef, { originX: positions[0].originX, originY: positions[0].originY }, { overlayX: positions[0].overlayX, overlayY: positions[0].overlayY })
            .withPositions(positions);
        positionStrategy.onPositionChange.subscribe(function (positionChange) {
            _this.tooltipRef.instance.placementType = positionChange.connectionPair;
        });
        this.overlayRef = this.overlay.create({ positionStrategy: positionStrategy });
    };
    /**
     * Returns the preferred positions array for chosen placement.
     * @returns {ConnectionPositionPair[]}
     */
    SisTooltipDirective.prototype.getPositions = function () {
        switch (this.placement) {
            case 'above':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.UP;
                break;
            case 'above-left':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.UP_LEFT;
                break;
            case 'above-right':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.UP_RIGHT;
                break;
            case 'below':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.DOWN;
                break;
            case 'below-left':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.DOWN_LEFT;
                break;
            case 'below-right':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.DOWN_RIGHT;
                break;
            case 'left':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.LEFT;
                break;
            case 'left-up':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.LEFT_UP;
                break;
            case 'left-down':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.LEFT_DOWN;
                break;
            case 'right':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.RIGHT;
                break;
            case 'right-up':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.RIGHT_UP;
                break;
            case 'right-down':
                this.defaultPosition = tooltip_configs_model_1.SisTooltipPosition.RIGHT_DOWN;
                break;
        }
        return tooltip_configs_model_1.SisTooltipPosition.getPositionArray(this.defaultPosition);
    };
    SisTooltipDirective.prototype.ngOnDestroy = function () {
        this.overlayRef.hasAttached() && this.overlayRef.detach();
    };
    __decorate([
        core_1.Input('sisTooltip'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "text", void 0);
    __decorate([
        core_1.Input('sisTooltipTemplateRef'),
        __metadata("design:type", core_1.TemplateRef)
    ], SisTooltipDirective.prototype, "contentTemplate", void 0);
    __decorate([
        core_1.Input('sisTooltipDisabled'),
        __metadata("design:type", Boolean)
    ], SisTooltipDirective.prototype, "disabled", void 0);
    __decorate([
        core_1.Input('sisTooltipOnClick'),
        __metadata("design:type", Boolean)
    ], SisTooltipDirective.prototype, "onClick", void 0);
    __decorate([
        core_1.Input('sisTooltipSize'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "size", void 0);
    __decorate([
        core_1.Input('sisTooltipPlacement'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], SisTooltipDirective.prototype, "placementType", null);
    __decorate([
        core_1.Input('sisTooltipTitle'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "title", void 0);
    __decorate([
        core_1.Input('sisTooltipCheckboxText'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "checkboxText", void 0);
    __decorate([
        core_1.Input('sisTooltipButtonText'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "buttonText", void 0);
    __decorate([
        core_1.Input('sisTooltipShowTitle'),
        __metadata("design:type", Boolean)
    ], SisTooltipDirective.prototype, "showTitle", void 0);
    __decorate([
        core_1.Input('sisTooltipShowDisableCheck'),
        __metadata("design:type", Boolean)
    ], SisTooltipDirective.prototype, "showDisableCheckbox", void 0);
    __decorate([
        core_1.Input('sisTooltipShowCloseButton'),
        __metadata("design:type", Boolean)
    ], SisTooltipDirective.prototype, "showCloseButton", void 0);
    __decorate([
        core_1.Input('sisTooltipClass'),
        __metadata("design:type", String)
    ], SisTooltipDirective.prototype, "tooltipClass", void 0);
    __decorate([
        core_1.Output('sisTooltipDisableCheck'),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTooltipDirective.prototype, "onDisableCheck", void 0);
    __decorate([
        core_1.Output('sisTooltipClosed'),
        __metadata("design:type", core_1.EventEmitter)
    ], SisTooltipDirective.prototype, "onTooltipClosed", void 0);
    __decorate([
        core_1.HostListener('mouseenter'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SisTooltipDirective.prototype, "onHoverEnter", null);
    __decorate([
        core_1.HostListener('mouseleave'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SisTooltipDirective.prototype, "onHoverLeave", null);
    __decorate([
        core_1.HostListener('document:click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SisTooltipDirective.prototype, "clickedOutside", null);
    __decorate([
        core_1.HostListener('click', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], SisTooltipDirective.prototype, "onHostClick", null);
    SisTooltipDirective = __decorate([
        core_1.Directive({
            selector: '[sisTooltip]'
        }),
        __metadata("design:paramtypes", [overlay_1.OverlayPositionBuilder,
            core_1.ElementRef,
            overlay_1.Overlay])
    ], SisTooltipDirective);
    return SisTooltipDirective;
}());
exports.SisTooltipDirective = SisTooltipDirective;
//# sourceMappingURL=sis-tooltip.directive.js.map